import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationEnd, Router } from '@angular/router';

import { Subject, filter, takeUntil } from 'rxjs';
import { AuthViewModel } from '../../../features/auth/viewmodels/auth.viewmodel';

@Component({
  selector: 'app-header',
  imports: [MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatTooltipModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  activeMenuItem: string = 'dashboard';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    readonly authViewModel: AuthViewModel
  ) {}

  ngOnInit(): void {
    this.updateActiveFromUrl(this.router.url);

    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        this.updateActiveFromUrl(event.urlAfterRedirects || event.url);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setActiveMenuItem(menuItem: string): void {
    this.activeMenuItem = menuItem;
  }

  onCompactMenuChange(menuItem: string): void {
    switch (menuItem) {
      case 'dashboard':
        this.navigateToDashboard();
        break;
      case 'participantes':
        this.navigateToParticipantes();
        break;
      case 'relatorios':
        this.navigateToRelatorios();
        break;
      case 'laboratorio':
        this.navigateToLaboratorio();
        break;
      case 'configuracoes':
        this.navigateToParametros();
        break;
    }
  }

  private updateActiveFromUrl(url: string): void {
    if (!url) return;
    if (url.startsWith('/dashboard')) {
      this.activeMenuItem = 'dashboard';
      return;
    }
    if (url.startsWith('/parametros')) {
      this.activeMenuItem = 'configuracoes';
      return;
    }
    if (url.startsWith('/participantes')) {
      this.activeMenuItem = 'participantes';
      return;
    }
    if (url.startsWith('/analise-documental/laboratorio')) {
      this.activeMenuItem = 'laboratorio';
      return;
    }
    this.activeMenuItem = 'dashboard';
  }

  navigateToLaboratorio(): void {
    this.setActiveMenuItem('laboratorio');
    this.router.navigate(['/analise-documental/laboratorio']);
  }

  navigateToParametros(): void {
    this.setActiveMenuItem('configuracoes');
    this.router.navigate(['/parametros']);
  }

  navigateToDashboard(): void {
    this.setActiveMenuItem('dashboard');
    this.router.navigate(['/dashboard']);
  }

  navigateToParticipantes(): void {
    this.setActiveMenuItem('participantes');
    this.router.navigate(['/participantes']);
  }

  navigateToRelatorios(): void {
    this.setActiveMenuItem('relatorios');
    // Adicione a rota para relatórios quando estiver disponível
    // this.router.navigate(['/relatorios']);
  }

}
